<template>
    <div>
      <Header></Header>
      <div class="box">
          <div class="body">
              <div class="header">
                  <img class="h-img" src="static/images/logo2.png" alt="">
              </div>
              <div style="margin: 20px 0;">
                  <p style="font-size: 22px; margin: 10px 0; font-weight: 600;">修改密码</p>
                  <div class="item">
                    <Icon class="icon-size" type="md-lock" />
                    <Input class="i-inp" v-model="oldpwd" placeholder="请输入旧密码"></Input>
                  </div>
                  <div class="item">
                    <Icon class="icon-size"  type="md-lock" />
                    <Input class="i-inp" v-model="passwd" type="password" placeholder="请输入新密码"></Input>
                  </div>
                  <div class="item">
                    <Icon class="icon-size"  type="md-lock" />
                    <Input class="i-inp" v-model="passwd_conf" type="password" placeholder="确认新密码"></Input>
                  </div>
                  <div class="item-d">
                      <Button @click="save" class="btn">保存</Button>
                      <Button @click="cancel" class="btn">取消</Button>
                  </div>
              </div>
          </div>
      </div>
    </div>
</template>
<script>
import helper from '../lib/helper'
import Header from './header'

export default {
  components: {
    Header
  },
  data () {
    return {
      oldpwd: '',
      passwd: '',
      passwd_conf: ''
    }
  },
  mounted () {
  },
  methods: {
    changeState () {
      this.oldpwd = ''
      this.passwd = ''
      this.passwd_conf = ''
    },
    cancel () {
      window.location.href = '/'
    },
    save () {
      console.log('save')
      if (this.oldpwd.length === 0) {
        this.$Message.info('旧密码不能为空')
        return
      }
      if (this.passwd.length === 0) {
        this.$Message.info('新密码不能为空')
        return
      }
      if (this.passwd_conf.length === 0) {
        this.$Message.info('确认新密码不能为空')
        return
      }
      if (this.passwd_conf !== this.passwd) {
        this.$Message.info('二次新密码输入不一致')
        return
      }

      var url = this.$store.state.baseurl + '/mapi/user/setpwd'
      console.log('url', url)
      var that = this
      this.axios.post(
        url,
        {
          oldPsw: this.oldpwd,
          newPsw: this.passwd,
          rePsw: this.passwd_conf
        }
      ).then(function (res) {
        if (res.data.code === 200) {
          console.log('登录成功', res.data)
          that.$Message.info(
            {
              content: res.data.msg,
              duration: 4
            })
          that.$router.push({
            path: `/`
          })
        } else if (res.data.code === 401) {
          helper.removeLogin()
          helper.removeUser()
          window.location.href = '/login'
        } else if (res.data.code === 403) {
          that.$Message.info('没有权限')
        } else {
          that.$Message.info(
            {
              content: res.data.msg,
              duration: 5
            })
        }
      }).catch((e) => {
        console.log('访问网络错误', e)
        that.$Message.info('访问网络错误')
      })
    }
  }
}
</script>
<style lang="less" scoped>
.box {
    display: flex;
    justify-content: center;
    flex-direction: row;
    width: 100%;
}
.body {
    width: 390px;
    border-radius: 10px;
    overflow: hidden;
    margin-top: 120px;
    border: 1px solid #eeeeee;
}
.header {
    width: 100%;
    height: 130px;
    background: #398dee;
    .h-img {
        position: relative;
        top: 37px;
        right: 11px;
    }
}
.item {
    // background: #87bdfb;
    margin: 19px 20px;
    padding: 5px;
    border-radius: 5px;
    .icon-size {
        font-size: 26px;
        position: relative;
        top: 4px;
    }
    .i-inp {
        width: 81%;
    }
    a:link{color: #2d8cf0;}
    a:hover{color: #2d8cf0;}
    a:visited{color: #2d8cf0;}
}
.btn {
    background: cornflowerblue;
    border-radius: 10px;
    height: 35px;
    color: #fff;
    line-height: 35px;
    width: 20%;
    margin: 0 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/setpwd.vue